var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.565,
    fill: "#fff",
    stroke: "#008938",
    strokeWidth: 0.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#008938",
    d: "M15.02 22.165v-5.454H9.973v-1.89h5.049V9.367h1.97v5.454h5.05v1.89h-5.05v5.454z"
  })));
};
export default SvgPlus;